'use strict';

var _require = require('./helpers/clickHelper'),
    bhInitClickEvent = _require.bhInitClickEvent;

$(function () {
  function addBHEventHandler() {
    var _OptimizeSuite = OptimizeSuite,
        bh = _OptimizeSuite.bloodhound;


    bh.on('event', bhInitClickEvent);
  }

  function setBHEventListener() {
    if (window.OptimizeSuite && window.OptimizeSuite.bloodhound) {
      return addBHEventHandler();
    }
    setTimeout(setBHEventListener, 100);
  }

  setBHEventListener();
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImJsb29kaG91bmRfaW50ZXJjZXB0LmpzIl0sIm5hbWVzIjpbInJlcXVpcmUiLCJiaEluaXRDbGlja0V2ZW50IiwiJCIsImFkZEJIRXZlbnRIYW5kbGVyIiwiT3B0aW1pemVTdWl0ZSIsImJoIiwiYmxvb2Rob3VuZCIsIm9uIiwic2V0QkhFdmVudExpc3RlbmVyIiwid2luZG93Iiwic2V0VGltZW91dCJdLCJtYXBwaW5ncyI6Ijs7ZUFBNkJBLFFBQVEsdUJBQVIsQztJQUFyQkMsZ0IsWUFBQUEsZ0I7O0FBRVJDLEVBQUUsWUFBTTtBQUNOLFdBQVNDLGlCQUFULEdBQTZCO0FBQUEseUJBQ0FDLGFBREE7QUFBQSxRQUNQQyxFQURPLGtCQUNuQkMsVUFEbUI7OztBQUczQkQsT0FBR0UsRUFBSCxDQUFNLE9BQU4sRUFBZU4sZ0JBQWY7QUFDRDs7QUFFRCxXQUFTTyxrQkFBVCxHQUE4QjtBQUM1QixRQUFJQyxPQUFPTCxhQUFQLElBQXdCSyxPQUFPTCxhQUFQLENBQXFCRSxVQUFqRCxFQUE2RDtBQUMzRCxhQUFPSCxtQkFBUDtBQUNEO0FBQ0RPLGVBQVdGLGtCQUFYLEVBQStCLEdBQS9CO0FBQ0Q7O0FBRURBO0FBQ0QsQ0FmRCIsImZpbGUiOiJibG9vZGhvdW5kX2ludGVyY2VwdC5qcyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IHsgYmhJbml0Q2xpY2tFdmVudCB9ID0gcmVxdWlyZSgnLi9oZWxwZXJzL2NsaWNrSGVscGVyJylcblxuJCgoKSA9PiB7XG4gIGZ1bmN0aW9uIGFkZEJIRXZlbnRIYW5kbGVyKCkge1xuICAgIGNvbnN0IHsgYmxvb2Rob3VuZDogYmggfSA9IE9wdGltaXplU3VpdGVcblxuICAgIGJoLm9uKCdldmVudCcsIGJoSW5pdENsaWNrRXZlbnQpXG4gIH1cblxuICBmdW5jdGlvbiBzZXRCSEV2ZW50TGlzdGVuZXIoKSB7XG4gICAgaWYgKHdpbmRvdy5PcHRpbWl6ZVN1aXRlICYmIHdpbmRvdy5PcHRpbWl6ZVN1aXRlLmJsb29kaG91bmQpIHtcbiAgICAgIHJldHVybiBhZGRCSEV2ZW50SGFuZGxlcigpXG4gICAgfVxuICAgIHNldFRpbWVvdXQoc2V0QkhFdmVudExpc3RlbmVyLCAxMDApXG4gIH1cblxuICBzZXRCSEV2ZW50TGlzdGVuZXIoKVxufSlcbiJdfQ==